import { Navigate, Outlet } from "react-router-dom";

// Define tus interfaces aquí si las necesitas para el tipado,
// pero no son estrictamente necesarias para la lógica.
interface Permission {
  Id: number;
  IdAction: number;
  // ...
}

interface Role {
  Id: number;
  RoleName: string;
  Permissions: Permission[];
}

const ProtectedRoute = () => {
  const userString = localStorage.getItem("user");
  
  if (!userString) {
    return <Navigate to="/login" replace />;
  }

  let userObject;
  try {
    const userData = JSON.parse(userString).userData;
    userObject = JSON.parse(userData);
  } catch (error) {
    console.error("Error parsing user data:", error);
    return <Navigate to="/login" replace />;
  }

  if (!userObject || !userObject.roles) {
    return <Navigate to="/login" replace />;
  }

  const permisosAplanados = userObject.roles.flatMap((rol: Role) =>
    rol.Permissions.map((permiso: Permission) => permiso.IdAction)
  );

  if (!permisosAplanados.includes(1)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;